<template>
  <article id="article-miniapp-setting">
    <section class="section-login">
      <div class="login-action">
        <div class="pre-login-profile">
          <img
            class="img-profile"
            v-if="getIslogin && getUser && getUser.profileUrl"
            :src="getUser.profileUrl"
            alt
          />
          <i v-else class="fas fa-user-circle no-img"></i>
        </div>
        <a
          v-if="!getIslogin"
          class="ctn-login"
          href="javascript:;"
          @click="login"
          data-action="register_or_login_setting"
          data-eventcategory="app_flow"
        >เข้าสู่ระบบ/สมัครสมาชิก</a>
        <a v-else class="user-email" href="javascript:;">{{ getUser.email }}</a>
      </div>
    </section>

    <section class="section-helper-links mb-40">
      <div class="description">General</div>
      <ul class="setting-list">
        <li class="setting-row">
          <router-link
            data-action="assets"
            data-eventcategory="app_flow"
            class="item"
            :to="{ name: 'miniapp-assets' }"
          >
            <div class="left">
              <i class="fas fa-coins"></i>
            </div>
            <div class="middle">Assets</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </router-link>
        </li>
      </ul>
    </section>

    <section class="section-helper-links">
      <div class="description">About FINNOMENA MONEY</div>
      <ul class="setting-list">
        <li class="setting-row">
          <a
            data-action="about_us"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('https://www.finnomena.com/about-us?webview=line&bt_id=71')"
            href="javascript:;"
          >
            <div class="left">
              <i class="fas fa-info-circle"></i>
            </div>
            <div class="middle">About Us</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
        <li class="setting-row">
          <router-link
            data-action="policy"
            data-eventcategory="app_flow"
            class="item"
            :to="{ name: 'miniapp-terms-and-conditions' }"
          >
            <div class="left">
              <i class="fas fa-route-interstate"></i>
            </div>
            <div class="middle">
              Terms & Conditions
            </div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </router-link>
        </li>
        <li class="setting-row">
          <a
            data-action="line_today"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('https://today.line.me/th/publisher/100077?webview=line')"
            href="javascript:;"
          >            
            <div class="left">
              <img :src="imgPath.lineToday" alt="FINNOMENA LINE TODAY" />
            </div>
            <div class="middle">FINNOMENA LINE TODAY</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
        <li class="setting-row">
          <a 
             data-action="line_tv"
             data-eventcategory="app_flow" 
             class="item"
             @click="openWindow('https://tv.line.me/search?query=FINNOMENA&webview=line')"
             href="javascript:;">
            <div class="left">
              <img :src="imgPath.lineTv" alt="FINNOMENA LINE TV" />
            </div>
            <div class="middle">FINNOMENA LINE TV</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>
          </a>
        </li>
        <li class="setting-row">
          <a
            data-action="line_finnomena_port"
            data-eventcategory="app_flow"
            class="item"
            @click="openWindow('http://line.me/ti/p/%40finnomena')"
            href="javascript:;"
          >
            <div class="left">
              <img :src="imgPath.line" alt="FINNOMENA LINE TV" />
            </div>
            <div class="middle">@FINNOMENA</div>
            <div class="right">
              <i class="fas fa-chevron-right"></i>
            </div>          
          </a>
        </li>
      </ul>
    </section>
    <section class="section-logout" v-if="getIslogin">
      <a
        class="ctn-logout"
        href="javascript:;"
        @click="logout"
        data-action="logout"
        data-eventcategory="app_flow"
      >ออกจากระบบ</a>
    </section>
  </article>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
export default {
  data() {
    return {
      imgPath: {
        lineToday: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/line-today-logo.png`,
        lineTv: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/line-tv-logo.png`,
        line: `${process.env.VUE_APP_SCONTENT_URL}/line-liff/line-logo.png`
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["getIslogin", "getUser"]),
    ...mapGetters("onboarding", ["getLineID"])
  },
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  methods: {
    ...mapActions("auth", ["authLogout"]),
    async login() {
      const uid = this.uid()
      let return_url = this.$route.fullPath;
      let email = "";

      if (this.getUser.email && this.getUser.email !== "") {
        email = `&email=${encodeURIComponent(this.getUser.email)}`;
      }

      window.location.replace(`/login?return_url=${encodeURIComponent(return_url)}${email}${uid}`)
    },
    async logout() {
      await this.authLogout()
      window.location = `/logout?redirect_uri=${encodeURIComponent(this.$route.fullPath)}`
    },
    openWindow(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
    uid() {
      if(this.getLineID) {
        const uid = `&uid=${this.getLineID}`
        return uid
      }

      return ""
    }
  }
}
</script>
<style lang="scss" scoped>
#article-miniapp-setting {
  position: relative;
  .section-login {
    text-align: center;
    display: table;
    width: 100%;
    .login-action {
      display: table-cell;
      vertical-align: middle;
      height: 200px;
      .pre-login-profile {
        width: 72px;
        height: 72px;
        position: relative;
        overflow: hidden;
        border-radius: 50%;
        margin: 0 auto;
        .img-profile {
          margin: 0 auto;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .no-img {
          font-size: 72px;
          color: #d8d8d8;
        }
      }
      .ctn-login {
        margin-top: 20px;
        display: inline-block;
        border-radius: 4px;
        padding: 8px 37.5px;
        text-decoration: none;
        @extend %font-size-s;
        font-weight: bold;
        @include finRippleBtn($color-primary-finno, $color-primary-finno, $color-normal-text);
      }
      .user-email {
        margin-top: 20px;
        display: inline-block;
        border-radius: 4px;
        padding: 8px 37.5px;
        text-decoration: none;
        @extend %font-size-s;
        font-weight: bold;
        color: $color-normal-text;
      }
    }
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .section-helper-links {
    .description {
      @extend %font-size-s;
      padding: 16px;
      color: $color-secondary;
    }
    .setting-list {
      padding: 0;
      margin: 0;
      .setting-row {
        pointer-events: none;
        display: inline-block;
        width: 100%;
        border-bottom: 1px solid $color-border !important;
        text-decoration: none;
        padding: 0px 16px;
        @include finRippleBtn($color-white, none, $color-normal-text);
        &:first-child {
          border-top: 1px solid $color-border;
        }
        a {
          display: block;
          text-decoration: none;
          @extend %font-size-s;
          color: $color-normal-text;
          pointer-events: auto;
          cursor: pointer;
          div {
            pointer-events: none;
          }
        }
        img {
          vertical-align: middle;
          max-width: 32px;
        }
        i {
          font-size: 24px;
          vertical-align: middle;
        }
        .fa-chevron-right {
          color: $color-light-grey-2;
          font-size: 14px;
        }
        .item {
          .left {
            text-align: center;
            @extend %font-size-s;
            color: $color-normal-text;
            @include finCol(1, 12, 0px, middle, true, false);
          }
          .middle {
            @extend %font-size-s;
            color: $color-normal-text;
            padding-top: 16px !important;
            padding-bottom: 16px !important;
            padding-left: 16px !important;
            @include finCol(10, 12, 0px, middle, false, false);
          }
          .right {
            text-align: right;
            right: 18px;
            @include finCol(1, 12, 0px, middle, false, true);
          }
        }
      }
    }
  }
  .section-logout {
    padding: 16px;
    margin-top: 60px;
    @media only screen and (max-width: 320px) {
      margin-top: 0px;
    }
    width: 100%;
    .ctn-logout {
      width: 100%;
      display: block;
      text-align: center;
      text-decoration: none;
      padding: 11px;
      border-radius: 4px;
      @extend %font-size-s;
      font-weight: bold;
      @include finRippleBtn($color-inactive, $color-inactive, $color-normal-text);
    }
  }
}
</style>